import React, { useState } from "react";
import logo from "./../../assets/logoins.png";
import { ButtonStyle } from "../../utils/Buttons/Buttons";
import Radio from "@mui/material/Radio";
import {useHistory} from 'react-router-dom'


import "./EFinalizarIdentidad.scss";

function EFinalizarIdentidad() {
  const history = useHistory();
  
  const NextOptions= () => {
    history.push('./GHola'+ history.location.search)
  };
  return (
    <div className="screen1">
      <div className="box_one" style={{marginBottom:'2em', marginTop: "20vh"}}>
        <p className="title1">¡Excelente!</p>
        <p className="title2">Tu identidad ha sido <br/> creada satisfactoriamente</p>
      </div>

   
      <div style={{ marginTop: "3em" }}>
        <ButtonStyle
          text="COMENZAR"
           onClick={() => NextOptions()}
          width="177px"
          height="5vh"
        />
      </div>
    </div>
  );
}
export default EFinalizarIdentidad;
